export const SERVICE_WORKER_UPDATE_INTERVAL_MS = 15 * 60 * 1000;

type UpdateHandlerOptions = {
  buildVersion?: string;
  reload?: () => void;
  storage?: Storage;
};

export const createServiceWorkerUpdateHandler = ({
  buildVersion,
  reload = () => window.location.reload(),
  storage = window.sessionStorage,
}: UpdateHandlerOptions = {}) => {
  let updateRequested = false;
  let reloading = false;
  const reloadKey = buildVersion
    ? `MenuPass@ServiceWorkerReload:${buildVersion}`
    : null;

  return {
    onUpdate(registration: ServiceWorkerRegistration) {
      if (updateRequested || !registration.waiting) {
        return;
      }

      updateRequested = true;
      registration.waiting.postMessage({ type: "SKIP_WAITING" });
    },

    onControllerChange() {
      if (!updateRequested || reloading) {
        return;
      }

      if (reloadKey && storage.getItem(reloadKey)) {
        return;
      }

      reloading = true;
      if (reloadKey) {
        storage.setItem(reloadKey, "reloaded");
      }
      reload();
    },
  };
};

export const startServiceWorkerUpdatePolling = (
  registration: ServiceWorkerRegistration,
  intervalMs = SERVICE_WORKER_UPDATE_INTERVAL_MS
) => {
  const intervalId = window.setInterval(() => {
    registration.update().catch((error) => {
      console.error("Unable to check for a service-worker update:", error);
    });
  }, intervalMs);

  return () => window.clearInterval(intervalId);
};
